import { defineComponent as _defineComponent } from 'vue'
interface Props {
  cols?: string;
  rows?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiPackery',
  props: {
    cols: { default: 'grid-cols-1' },
    rows: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})